exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dsn-modal{background-color:rgba(0,0,0,.22)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4fb04e96","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/modalComponents/modalAlerte/modalAlerte.scss
// module id = uZS5
// module chunks = 2